/**
 * Constants, string dictionaries, and configurations for CuadroPicnicComponent.
 */

import { OperationalPicnicServiceCategory } from './operational-services.util';

/**
 * Ordered list of table column identifiers displayed in the main Cuadro Picnic MatTable.
 */
export const DISPLAYED_TABLE_COLUMNS: string[] = [
  'fechaOperacion',
  'fileNumber',
  'nameClient',
  'tipoAlimento',
  'reservationExecutive',
  'guiaPrincipal',
  'activityName',
  'pax',
  'tc',
  'driver',
  'guia',
  'asistGuia',
  'fieldStaff',
  'staff',
  'total',
  'infante',
  'nino',
  'restriccionesAlimentarias',
  OperationalPicnicServiceCategory.TRANSPORT,
  OperationalPicnicServiceCategory.ASSISTANT,
  OperationalPicnicServiceCategory.BATHROOM_ATTENDANT,
  OperationalPicnicServiceCategory.OPERATOR,
  'isPicnicOrderReviewed',
  'pendingCsReviews',
  'observacionProgramadora',
];

/**
 * Available years for table filtering.
 */
export const AVAILABLE_YEARS_LIST: string[] = ['2024', '2025', '2026', '2027'];

/**
 * Page size selector options for MatPaginator.
 */
export const DEFAULT_PAGE_SIZE_OPTIONS: number[] = [10, 25, 50];

/**
 * Spanish localization labels for MatPaginatorIntl.
 */
export const PAGINATOR_SPANISH_LABELS = {
  itemsPerPage: 'Filas por página:',
  nextPage: 'Página siguiente',
  previousPage: 'Página anterior',
  firstPage: 'Primera página',
  lastPage: 'Última página',
} as const;

/**
 * SweetAlert and toast messaging texts for order review interactions ('Revisado Pedido').
 */
export const ORDER_REVIEW_MESSAGES = {
  confirmTitleReviewed: '¿Confirmar Revisión de Pedido?',
  confirmTitlePending: '¿Marcar Pedido como Pendiente?',
  confirmButtonReviewed: 'Sí, confirmar revisión',
  confirmButtonPending: 'Sí, marcar como pendiente',
  cancelButton: 'Cancelar',
  actionReviewedHtml:
    'marcar como <span style="color: #15803d; font-weight: 700;">REVISADO Y APROBADO</span>',
  actionPendingHtml:
    'marcar como <span style="color: #b45309; font-weight: 700;">PENDIENTE DE REVISIÓN</span>',
  successTitleReviewed: 'Pedido Revisado',
  successTitlePending: 'Pedido Pendiente',
  errorIdentifierTitle: 'Error de Identificador',
  errorIdentifierText:
    'No se encontró el identificador de actividad para actualizar la revisión del pedido.',
  errorUpdateTitle: 'Error al Actualizar',
  errorUpdateText:
    'No se pudo actualizar el estado de revisión en la base de datos de Core.',
  errorConnectionTitle: 'Error de Comunicación',
  errorConnectionText:
    'Ocurrió un error de conexión al actualizar la revisión del pedido en Core. Intente nuevamente.',
} as const;
